import { Card, DatePicker, Select } from 'antd';
import React from 'react';

import Fieldset from 'components/Fieldset';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';

const AdditionalInfos = () => {
  return (
    <Card
      title={
        <GetLabel
          label="additional-info"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      bordered
    >
      <Fieldset comcode="additional-info">
        <FormInput col xs={24} md={12} name="ctriskstatus">
          <Select />
        </FormInput>
        <FormInput col xs={24} md={12} name="ctriskstatusdate">
          <DatePicker />
        </FormInput>
        <FormInput col xs={24} md={12} name="ctfree1" />
        <FormInput col xs={24} md={12} name="ctfree2" />
        <FormInput col xs={24} md={12} name="ctfree3" />
        <FormInput col xs={24} md={12} name="ctfree4" />
      </Fieldset>
    </Card>
  );
};

export default AdditionalInfos;
